import * as React from 'react';
import { useState } from 'react';
import { CustomReferenceRole, Reference, Part, PartDefinition, ReferenceAssignmentsRequest, selectAllReferenceRoles, getShortTypeName, getUasId, selectAllPartDefinitions, getRefMap, getPartValue, selectCurrentReference, selectReferenceAssignments, selectAllReferences, loadAllTaxonomyReferences, loadAllReferenceAssignments, clearSelectedReference, setSelectedReference } from '../../../redux/TaxonomyReferenceSlice';
import { useAppSelector, useAppDispatch } from '../../../hooks/index';
import { FormGroup, Input, FormFeedback, Container, Row, Col, Label, Toast, ToastHeader, ToastBody } from 'reactstrap';
import Select, { useEffect } from 'react-select';
import { DtsConcept, loadTaxonomyConcept, resetTaxonomyConceptState, getSelectedTaxonomyConcept } from '../../../redux/TaxonomyConceptSlice';
import enums from '../../../utils/enums';
import { selectEditReference, getTaxonomyChanges, addReferenceRoleChange, TaxonomyChangesState } from '../../../redux/TaxonomyChangesSlice';
import utilityHelper from '../../../utils/utilityHelper';
import { setIsTaxonomyDirty } from '../../../redux/TaxonomyVersionSlice';
import { Edit } from '../../../redux/MiscSlice';


import './ModalPopUp.css';
import Modal from './Modal';
//import { statSync } from 'node:fs';

interface ddSelection {
    dropdown: string,
    dropdowntype: string,
    role: CustomReferenceRole | null
}

interface ddOption {
    name: string;
    documentation: string;
}

function SelectNewReferenceTypeModal(props: any) {

    const dispatch = useAppDispatch();
    var versionedConcept: DtsConcept | null = useAppSelector(getSelectedTaxonomyConcept);
    var partDefinitions: PartDefinition[] = useAppSelector(selectAllPartDefinitions);
    var changes: TaxonomyChangesState | null = useAppSelector(getTaxonomyChanges);
    const currentReference: Reference | null = useAppSelector(selectEditReference);

    const [state, setState] = useState<Array<ddSelection>>([{
        dropdown: "",
        dropdowntype: "",
        role: null
    }]);

    const [idMap, setIdMap] = useState(
        props.availableReferences.reduce(function (map : any, r : Reference) {
            map[getUasId(r, null)] = r;
            return map;
        }, {}));
    const [refType, setRefType] = useState("http://www.xbrl.org/2003/role/reference")
    const [refId, setRefId] = useState("");
    const [refName, setRefName] = useState("");
    const [refDate, setRefDate] = useState(new Date().toISOString().split('T')[0]);
    const [customName, setCustomName] = useState("");
    const [customDocumentation, setCustomDocumentation] = useState("");

    const referenceRoles = useAppSelector(selectAllReferenceRoles);
    const convertToOption = function (role: CustomReferenceRole): ddOption {
        if (!role) {
            return { name: "", documentation: "" };
        }
        return { name: getShortTypeName(role), documentation: role.documentation };
    }
    const collectReferenceRoles = function (): CustomReferenceRole[] {
        var result: CustomReferenceRole[] = [];
        if (referenceRoles) {
            result = result.concat(referenceRoles);
        }
        if (changes) {
            result = result.concat(changes.customRoleChanges);
        }
        return result;
    }
    const [allReferenceRoles, setAllReferenceRoles] = useState<CustomReferenceRole[]>(collectReferenceRoles());

    const getOptions = function (): ddOption[] {
        var options: ddOption[] = [];
        for (var pd of allReferenceRoles) {
            options.push(convertToOption(pd));
        }
        return options;
    }
    const [optionList, setOptionList] = useState(getOptions());

    const [selectedOption, setSelectedOption] = useState<any>({ name: "", documentation: "" });

    // Handle Event
    const handleChange = (e: any, action: any) => {

        var ddName: string = action.name;
        var roleName: string = e.value;
        var role: CustomReferenceRole | null = null;
        var ddType = "CustomReferenceRole";
        var option: ddOption = { name: "", documentation: "" };
        var roleDef: CustomReferenceRole | null | undefined = (allReferenceRoles.length > 0) ? allReferenceRoles.find(ro => getShortTypeName(ro) === roleName) : null;
        if (roleDef) {
            option = { name: roleDef.name, documentation: roleDef.documentation };
        }
        setSelectedOption(option);
        var newState = JSON.parse(JSON.stringify(state));
        newState.role = roleDef;

        var index = newState.findIndex((itm: any) => itm.dropdown === ddName);
        var selectedValue = { dropdown: ddName, dropdowntype: ddType, role: roleDef }


        if (index === -1) {
            newState.push(selectedValue)
        } else {
            newState[index] = selectedValue
        }
        newState.sort((a: any, b: any) => a.dropdown > b.dropdown ? 1 : -1);

        setState(newState);

    }


    const allowsDuplicateParts = (): boolean => {
        return false;
    }
    const getPartDefinition = function (partName: string): PartDefinition {
        var result: any = { name: partName, documentation: "", datatype: "", group: "", deprecationDate: ""};
        if (partDefinitions) {
            var matches = partDefinitions.filter(pd => pd.name === partName);
            if (matches.length > 0) {
                result = matches[0];
            }
        }
        return result;
    }

    const handleNew = () : Reference | null => {
        if (!versionedConcept || !versionedConcept.concept) {
            return null;
        }

        var refcode = versionedConcept.concept.code;
        var maxRank = 0;
        for (var r of versionedConcept.concept.references) {
            if (r.type !== enums.referenceTypes.private) {
                continue;
            }
            var rid = getUasId(r, null);
            var ridParts = rid.split("_");
            var ridPartsLastElement = ridParts.pop();
            var localRank = ridPartsLastElement !== undefined && ridParts.length >= 0 ? parseInt(ridPartsLastElement) : 0;
            if (localRank > maxRank) {
                maxRank = localRank;
            }
        }
        maxRank++;
        var newId = refcode + "_" + maxRank;
        var newRef: Reference = {
            type: enums.referenceTypes.private,
            parts: [
                {
                    definition: getPartDefinition("UASID"),
                    value: newId
                },
                {
                    definition: getPartDefinition("Name"),
                    value: "Local " + refcode + "_" + maxRank
                },
                {
                    definition: getPartDefinition("IssueDate"),
                    value: new Date().toISOString().split('T')[0]
                }
            ],
            dirty: true,
            new: true
        };
        return newRef;
    }

    const hasInvalidIdChars = function (candidate: string): boolean {
        for (var c = 0; c < candidate.length; c++) {
            if (" ,;\"'\\/(){}[]".indexOf(candidate[c]) >= 0) {
                console.log("invalid char: ", candidate[c], c);
                return true;
            }
        }
        return false;
    }
    const isUniqueId = function (candidate: string): boolean {
        if (idMap.hasOwnProperty(candidate)) {
            return false;
        }
        return true;
    }

    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "UASID":
                if (!refId || refId.length === 0) {
                    result = false;
                } else if (hasInvalidIdChars(refId)) {
                    result = false;
                } else if (!isUniqueId(refId)) {
                    result = false;
                }
                break;
            case "Name":
                if (!refName || refName.length === 0) {
                    result = false;
                }
                break;
            case "documentation":
                //                if (!documentation || documentation.length === 0) {
                //                    result = false;
                //                }
                break;
        }
        return result;
    }
    const isAnyInvalid = () => {
        if (!isValid("UASID ") || !isValid("Name")) {
            return true;
        }
        if (selectedOption && selectedOption.name.length === 0) {
            return true;
        }
        return false;
    }

    const handleNewShared = (): Reference => {
        var refType = enums.referenceTypes.standard;
        if (selectedOption && selectedOption.name.length > 0) {
            refType = selectedOption.name;
        }
        var newRef: Reference = {
            type: refType,
            parts: [
                {
                    definition: getPartDefinition("UASID"),
                    value: refId
                },
                {
                    definition: getPartDefinition("Name"),
                    value: refName
                },
                {
                    definition: getPartDefinition("IssueDate"),
                    value: refDate
                }
            ],
            dirty: true,
            new: true
        };
        return newRef;
    }

    const setTaxonomyDirty = function () {
        var estate: Edit = {
            IsDirty: true,
            Page: ""
        }
        dispatch(setIsTaxonomyDirty(estate));
    }

    // browse the and save temporarily in redux store
    const handleAddNewReference = (e: any) => {
        // saving in AFR slice
        var updatedReference = handleNewShared();
        setRefType("http://www.xbrl.org/2003/role/reference");
        setRefId("");
        setRefName("");
        setRefDate(new Date().toISOString().split('T')[0]);

        //close modal
        props.onCloseModal(updatedReference);

    }

    const handleCancel = (e: any) => {
        setRefType("http://www.xbrl.org/2003/role/reference");
        setRefId("");
        setRefName("");
        setRefDate(new Date().toISOString().split('T')[0]);
        //close modal
        props.onCloseModal(null);
    }



    function renderRoles(options: any) {

        return (
            <React.Fragment key={'ReferenceTypes'}>

                <Container>
                    <Row xs="1">
                        <Col>
                            <Label ><b>Reference Types Available:</b></Label>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <Select
                                name={'ReferenceTypes'}
                                onChange={handleChange}
                                autoFocus
                                options={options}
                                isOptionDisabled={(option: any) => option.isdisabled}
                                style={{ width: "25em" }}
                            />

                        </Col>
                    </Row>
                </Container>
            </React.Fragment >
        );
    }

    function generateDropdownValues(updateState: boolean) {

        var render = [];
        var ddState: Array<ddSelection> = [];
        var axe_i: number = 1;

        const options = getOptions().map(opc => ({
            value: opc.name,
            label: opc.name,
            isdisabled: false
        }));

        options.sort((a, b) => a.value > b.value ? 1 : -1);


        // render accounts
        render.push(renderRoles(options));
        ddState.push({ dropdown: 'ReferenceTypes', dropdowntype: "CustomReferenceRole", role: null })


        if (updateState) {
            setState(ddState);
        }

        return render;

    }

    const [renderPage, setRenderPage] = useState(generateDropdownValues(false));

    React.useEffect(() => {
        setAllReferenceRoles(collectReferenceRoles());
        setRenderPage(generateDropdownValues(true));
        setSelectedOption({ name: "", documentation: "" });

    }, [props]);

    React.useEffect(() => {
        setAllReferenceRoles(collectReferenceRoles());
        setRenderPage(generateDropdownValues(true));
        setSelectedOption({ name: "", documentation: "" });

    }, [changes]);


    return (
        <React.Fragment >
            <Modal size="xl" isOpen={props.isOpen} onClose={props.onCloseModal}>
                <div className="ModalPopUp">
                    <h4>Creating a new Reference</h4>
                    <br />
                    <br />
                    <Row>
                        <Col>
                            {props.isOpen && renderPage /* generateDropdownValues()*/}
                            <Row xs="1">
                                {selectedOption.name.length > 0
                                    ?
                                    <div style={{ marginTop: "1em", marginRight: "1em", marginLeft: "1em", width: "100%" }} >
                                        <Toast>
                                            <ToastHeader><b>Description for {getShortTypeName(selectedOption)}</b></ToastHeader>
                                            <ToastBody>{selectedOption.documentation}</ToastBody>
                                        </Toast>
                                    </div>
                                    :
                                    <div></div>
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="16" >
                            <FormGroup>

                                <Row>
                                    <Col >
                                        <Label><b>ID:</b></Label>
                                        <Input type="text" value={refId}
                                            onChange={(e) => setRefId(e.currentTarget.value)}
                                            valid={isValid("UASID")}
                                            invalid={(!isValid("UASID"))} />
                                        <FormFeedback>UASID is required, and must be unique. No spaces or punctuation allowed.</FormFeedback>
                                        <Label><b>Effective Date:</b></Label>
                                        <Input type="date" value={refDate}
                                            onChange={(e) => setRefDate(e.currentTarget.value)}
                                            valid={isValid("IssueDate")}
                                            invalid={(!isValid("IssueDate"))} />
                                        <FormFeedback>Effective date is required.</FormFeedback>
                                        <Label><b>Name:</b></Label>
                                        <Input type="text" value={refName}
                                            onChange={(e) => setRefName(e.currentTarget.value)}
                                            valid={isValid("Name")}
                                            invalid={(!isValid("Name"))} />
                                        <FormFeedback>Name is required.</FormFeedback>
                                    </Col>
                                </Row>

                            </FormGroup>
                        </Col>
                    </Row>

                    <div>
                        <button onClick={handleAddNewReference} disabled={isAnyInvalid()} className="btn btn-primary mr-4">
                            Add
                        </button>
                        <button onClick={handleCancel} className="btn btn-primary">
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        </React.Fragment >
    );
}

export default SelectNewReferenceTypeModal;